import i18next from 'i18next';

import { SEAT_PLANS, SUBSCRIPTION_VARIANTS } from '#constants/subscriptions';

const { BASIC, PREMIUM } = SEAT_PLANS;
const { MONTHLY, ANNUAL } = SUBSCRIPTION_VARIANTS;

i18next.addResources('es', 'SubscriptionBuilder', {
  title: 'Configurá la suscripción de tu estudio jurídico',
  subtitle:
    'Elegí tu plan y el paquete según la cantidad de usuarios que formarán parte. El costo total se actualiza automáticamente que elegís.',
  [MONTHLY]: 'Mensual',
  [ANNUAL]: 'Anual',
  choosePlan: 'Elegí tu plan',
  recommended: 'Recomendado',
  [`${BASIC}Name`]: 'Plan Básico',
  [`${BASIC}Description`]: 'Para organizar tus expedientes y tu agenda.',
  [`${BASIC}Feature1`]: 'Carga de expedientes públicos desde PJN, MEV y EJE',
  [`${BASIC}Feature2`]: 'Carga manual de causas',
  [`${BASIC}Feature3`]: 'Agenda y recordatorios',
  [`${BASIC}Feature4`]: 'Templates de escritos',
  [`${BASIC}Feature5`]: 'Asistente IA para resolución de causas y creación de escritos',
  [`${BASIC}Feature6`]: 'Formularios de inicio para sorteo de expedientes',
  [`${PREMIUM}Name`]: 'Plan Premium',
  [`${PREMIUM}Description`]: 'Para acceder a tus expedientes privados y recibir cédulas electrónicas.',
  [`${PREMIUM}Feature1`]: 'Todas las del plan básico',
  [`${PREMIUM}Feature2`]: 'Importación automática de expedientes con credencial desde PJN',
  [`${PREMIUM}Feature3`]: 'Importación automática de cédulas electrónicas con credencial desde PJN',
  choosePackage:
    'Seleccioná el paquete según la cantidad de usuarios que formarán parte del espacio de trabajo',
  choosePackageDescription: 'Cuentas habilitadas con sincronización continua de expedientes judiciales',
  mostPopular: 'Más popular',
  packageNumber: 'Paquete {{number}}',
  packageMails: '{{count}} Usuarios',
  package1Description: 'Incluye {{count}} correos electrónicos',
  package2Description: 'Incluye {{count}} correos electrónicos',
  package3Description: 'Incluye {{count}} correos electrónicos',
  basePrice: 'Valor base mensual:',
  plusIvaPerMonth: '+ IVA / mes',
  extraSeats: 'Correos electrónicos adicionales',
  extraSeatsDescription:
    'Para secretarios, procuradores o asociados que necesiten su propia cuenta de correo.',
  optional: 'Opcional',
  individualSeat: 'Casilla individual',
  individualSeatPrice: '{{price}} por mes, cada una',
  decrease: 'Quitar casilla',
  increase: 'Agregar casilla',
  enterpriseTitle: '¿Tu estudio necesita más de {{max}} correos electrónicos?',
  enterpriseDescription: 'Escribinos y armamos una cotización a medida para tu estudio.',
  whatsapp: 'WhatsApp',
  email: 'Email',
  enterpriseMessage: 'Hola, necesito más de {{max}} usuarios para mi estudio.',
  enterpriseResponseTime: 'Te respondemos en horario hábil.',
  summaryTitle: 'Resumen de tu suscripción',
  included: 'Incluido',
  summaryPackage: '{{name}} · {{count}} usuarios',
  summaryExtraNone: 'Usuarios adicionales (0)',
  summaryExtra: 'Usuarios adicionales ({{count}})',
  subtotal: 'Subtotal',
  [`total_${MONTHLY}`]: 'Total por mes',
  [`total_${ANNUAL}`]: 'Total por año',
  [`billing_${MONTHLY}`]: 'IVA incluido · Facturación mensual',
  [`billing_${ANNUAL}`]: 'IVA incluido · Facturación anual',
  pay: 'Pagar',
  onlyOwnerCanPay: 'Para continuar con el pago es necesario contactar con el dueño del espacio de trabajo',
  changePlan: 'Cambiar plan',
  mercadoPagoPayment: 'Pago seguro a través de Mercado Pago',
  notEnoughSeats:
    'Tu estudio ya tiene {{count}} usuarios (incluyendo invitaciones pendientes). Elegí un paquete con al menos esa cantidad.',
  currentPlan: 'Este es tu plan actual.',
  backToPlans: 'Volver a los planes',
  subscribe: 'Suscribirme',
  recurringCharge: 'Se cobrará automáticamente todos los meses en esta tarjeta',
  firstChargeDate:
    'El primer cobro se realizará el {{date}}, cuando termine tu período actual. Hasta entonces no se te cobra nada.',
  catalogError: 'No pudimos cargar los planes. Recargá la página para volver a intentar.',
  loadingPayment: 'Cargando el formulario de pago...',
  paymentFormError:
    'No pudimos cargar el formulario de pago. Revisá que ningún bloqueador de anuncios esté bloqueando Mercado Pago y volvé a intentar.'
});
